import { fetchOrganizations } from 'admin/actions/organization';
import { Button } from 'admin/components/atoms/Buttons';
import Headings from 'admin/components/atoms/Headings';
import Loader from 'admin/components/atoms/Loader';
import Select from 'admin/components/atoms/Select';
import Table from 'admin/components/atoms/Table';
import BreadCrumb from 'admin/components/molecules/BreadCrumb';
import Pager from 'admin/components/shared/Pager';
import usePartnerClients from 'admin/hooks/usePartnerClients';
import { formatDate, formatUUID } from 'admin/utils';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { createBadge } from '../../atoms/Badge';

const FormWrapper = styled.div`
  ${Select} {
    margin-bottom: 5px;
    width: 500px;
  }
  ${Button} {
    margin-bottom: 10px;
  }
`;

const SearchResult = styled.span`
  display: inline-block;
  margin-left: 1rem;
`;

const LoaderWrapper = styled.div`
  background: #f5f5f5;
  text-align: center;
  padding: 1rem;
`;

const Badge = createBadge({
  ENABLED: {
    label: '有効',
  },
  DISABLED: {
    label: '無効',
    bgColor: 'grey',
  },
});

const PartnerClients = () => {
  const crumbs = [
    { value: 'ホーム', href: '/', isCurrentPage: false },
    { value: 'サービス管理', href: '', isCurrentPage: true },
    { value: 'PartnerClient', href: '', isCurrentPage: true },
  ];

  const [isLoading, partnerClients, pagination, count, error, getPartnerClients] =
    usePartnerClients();

  const [organizationOptions, setOrganizationOptions] = useState(null);
  const [selectedOrganization, setSelectedOrganization] = useState(null);

  const handleChangePage = (page) => {
    getPartnerClients({ page });
  };

  useEffect(() => {
    fetchOrganizations('per_page=10000').then((res) => {
      const orgs = res.rows.map((o) => ({ label: o.name, value: o }));
      setOrganizationOptions(orgs);
    });
  }, []);

  useEffect(() => {
    if (selectedOrganization !== null) {
      const query = { organization_code: selectedOrganization.value.code };
      getPartnerClients(query);
    }
  }, [selectedOrganization]);

  return (
    <FormWrapper>
      <BreadCrumb crumbs={crumbs} />
      <Link to="/service-settings/partner-client/create">
        <Button>PartnerClient登録</Button>
      </Link>
      <div>
        <Select
          options={organizationOptions}
          value={selectedOrganization}
          onChange={setSelectedOrganization}
          placeholder="組織を選択してください。"
        />
      </div>
      {isLoading ? (
        <LoaderWrapper>
          <Loader type="Oval" height={50} width={50} />
        </LoaderWrapper>
      ) : (
        <div>
          <Headings.h5 style={{ marginTop: '16px' }}>検索結果</Headings.h5>
          <SearchResult> 件数：{count}</SearchResult>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.Cell size="1" align="center">
                  状態
                </Table.Cell>
                <Table.Cell size="1" align="center">
                  ID
                </Table.Cell>
                <Table.Cell size="2" align="center">
                  PartnerClient名
                </Table.Cell>
                <Table.Cell size="2" align="center">
                  管理ユーザ
                </Table.Cell>
                <Table.Cell size="2" align="center">
                  組織名
                </Table.Cell>
                <Table.Cell size="1.5" align="center">
                  作成日時
                </Table.Cell>
                <Table.Cell size="1.5" align="center">
                  更新日時
                </Table.Cell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {partnerClients.map((partnerClient) => (
                <Table.Row key={partnerClient.id}>
                  <Table.Cell align="center" wordBreak="keep-all">
                    <Badge status={partnerClient.status} />
                  </Table.Cell>
                  <Table.Cell align="center" wordBreak="keep-all">
                    <Link to={`/service-settings/partner-client/${partnerClient.id}`}>
                      {formatUUID(partnerClient.id)}
                    </Link>
                  </Table.Cell>
                  <Table.Cell align="center">{partnerClient.name}</Table.Cell>
                  <Table.Cell align="center">{partnerClient.admin_user.name}</Table.Cell>
                  <Table.Cell align="center">{partnerClient.organization.name}</Table.Cell>
                  <Table.Cell align="center">{formatDate(partnerClient.created_at)}</Table.Cell>
                  <Table.Cell align="center">{formatDate(partnerClient.updated_at)}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
            <Table.Footer>
              <Table.Row noBorder>
                <Table.Cell colSpan="7" align="center" styles={{ paddingTop: '16px' }}>
                  <Pager pagination={pagination} onChangePage={handleChangePage} />
                </Table.Cell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </div>
      )}
    </FormWrapper>
  );
};

export default PartnerClients;
